import React from 'react'
import styled from 'styled-components'

const Wrapper= styled.div`
  flex: 1;
  width: 100%;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  color: #f7f9f8;

  & input {
    flex: 1;
    padding: 4px;
  }
  & input::placeholder {
    color: #f7f9f8;
  }
`

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
}
export const Input = React.forwardRef((
  props: InputProps, 
  ref:any
) => {
  return (
    <Wrapper className='debug-rx'>
      <input {...props} ref={ref} />
    </Wrapper>
  )
})
